import { render } from "./BaseTag.vue?vue&type=template&id=b5b916f6&scoped=true"
import script from "./BaseTag.vue?vue&type=script&lang=js"
export * from "./BaseTag.vue?vue&type=script&lang=js"

import "./BaseTag.vue?vue&type=style&index=0&id=b5b916f6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b916f6"]])

export default __exports__